import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const legalSections = [
  {
    eyebrow: 'Anbieter',
    title: 'Angaben gemäß § 5 DDG',
    content: (
      <>
        <strong>EOS Energy Systems GmbH</strong><br />
        Blütenweg 10<br />
        78357 Mühlingen<br />
        Deutschland
      </>
    ),
  },
  {
    eyebrow: 'Vertretung',
    title: 'Gesetzlich vertreten durch',
    content: (
      <>
        Geschäftsführung: Eugen Stoppel
      </>
    ),
    note:
      'Hinweis: Bei einer GmbH gehört mindestens eine vertretungsberechtigte Person zu den Pflichtangaben. Deshalb ist dieser Punkt sachlich aufgeführt.',
  },
  {
    eyebrow: 'Kontakt',
    title: 'Schnelle Kontaktaufnahme',
    content: (
      <>
        Telefon: <a href={`tel:${mockData.contact.phone.replace(/\s/g, '')}`}>{mockData.contact.phone}</a><br />
        E-Mail: <a href={`mailto:${mockData.contact.email}`}>{mockData.contact.email}</a>
      </>
    ),
  },
  {
    eyebrow: 'Register',
    title: 'Registereintrag',
    content: (
      <>
        Eintragung im Handelsregister<br />
        Registergericht: Amtsgericht Freiburg<br />
        Registernummer: HRB 732512
      </>
    ),
  },
  {
    eyebrow: 'Steuer',
    title: 'Umsatzsteuer-ID',
    content: (
      <>
        Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
        DE451662094
      </>
    ),
  },
  {
    eyebrow: 'Handwerk',
    title: 'Zuständige Kammer',
    content: (
      <>
        Handwerkskammer Konstanz<br />
        Eingetragener Fachbetrieb
      </>
    ),
  },
];

const infoSections = [
  {
    title: 'Verbraucherstreitbeilegung',
    text:
      'Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
  },
  {
    title: 'Verantwortung für Inhalte',
    text:
      'Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität übernehmen wir jedoch keine Gewähr. Verpflichtungen zur Entfernung oder Sperrung rechtswidriger Inhalte bleiben hiervon unberührt.',
  },
  {
    title: 'Links zu externen Seiten',
    text:
      'Diese Website kann Links zu externen Angeboten enthalten. Auf deren Inhalte haben wir keinen Einfluss; verantwortlich ist der jeweilige Anbieter der verlinkten Seite.',
  },
  {
    title: 'Urheberrecht',
    text:
      'Texte, Bilder und Gestaltung dieser Website unterliegen dem deutschen Urheberrecht. Eine Nutzung außerhalb der gesetzlich erlaubten Grenzen bedarf der vorherigen Zustimmung der jeweiligen Rechteinhaber.',
  },
];

export default function Impressum() {
  return (
    <main id="impressum" data-bg="light" className="min-h-screen bg-[#f6f7fb] text-[#1f2937]">
      <section className="relative isolate overflow-hidden bg-[#02030a] text-white">
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_15%_10%,rgba(63,81,181,0.52),transparent_34%),linear-gradient(135deg,#00094d_0%,#02030a_58%,#050816_100%)]" />
        <div className="absolute inset-x-0 bottom-0 -z-10 h-32 bg-gradient-to-t from-[#f6f7fb] to-transparent" />

        <div className="mx-auto flex min-h-[44vh] max-w-7xl flex-col px-6 pb-16 pt-28 lg:px-8 lg:pt-32">
          <Link
            to="/"
            className="mb-12 inline-flex w-fit items-center gap-3 rounded-full border border-white/15 bg-white/8 px-4 py-2 text-sm text-white/78 backdrop-blur hover:border-white/35 hover:text-white"
            aria-label="Zurück zur Startseite"
          >
            <span aria-hidden="true">←</span>
            Zur Startseite
          </Link>

          <div className="max-w-3xl">
            <p className="text-sm font-semibold uppercase tracking-[0.32em] text-white/56">Rechtliche Angaben</p>
            <h1 className="mt-5 text-4xl font-semibold tracking-[-0.04em] sm:text-5xl lg:text-6xl">
              Impressum
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-8 text-white/70 sm:text-lg">
              Pflichtinformationen zur EOS Energy Systems GmbH – klar strukturiert, dauerhaft erreichbar und im Stil der Website gehalten.
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-20 pt-10 lg:px-8 lg:pb-28">
        <div className="grid gap-6 lg:grid-cols-[0.82fr_1.18fr] lg:gap-8">
          <aside className="rounded-[2rem] border border-[#dfe3ef] bg-white p-6 shadow-[0_24px_80px_rgba(0,9,77,0.08)] lg:sticky lg:top-8 lg:self-start">
            <img
              src="/EOS-Energy-Systems-Logo.png"
              alt="EOS Energy Systems GmbH"
              className="h-auto w-44"
            />
            <div className="mt-8 space-y-5 text-sm leading-7 text-[#4b5563]">
              <p>
                Die Seite enthält die wesentlichen Angaben nach § 5 DDG: Anbieter, Anschrift, Kontakt, Vertretung, Register und Umsatzsteuer-ID.
              </p>
              <p>
                Persönliche Namen sind nur dort aufgeführt, wo sie für die gesetzliche Vertretung der GmbH erforderlich sind.
              </p>
            </div>
            <div className="mt-8 rounded-2xl bg-[#00094d] p-5 text-white">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-white/50">Kontakt</p>
              <p className="mt-3 text-sm leading-7 text-white/78">
                {mockData.contact.address}<br />
                {mockData.contact.phone}<br />
                {mockData.contact.email}
              </p>
            </div>
          </aside>

          <div className="space-y-6">
            <div className="grid gap-4 sm:grid-cols-2">
              {legalSections.map((section) => (
                <article
                  key={section.title}
                  className="rounded-[1.75rem] border border-[#dfe3ef] bg-white p-6 shadow-[0_18px_60px_rgba(31,41,55,0.06)]"
                >
                  <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#3f51b5]">{section.eyebrow}</p>
                  <h2 className="mt-3 text-xl font-semibold tracking-[-0.02em] text-[#111827]">{section.title}</h2>
                  <p className="mt-4 text-sm leading-7 text-[#4b5563]">{section.content}</p>
                  {section.note && (
                    <p className="mt-5 rounded-2xl bg-[#f6f7fb] p-4 text-xs leading-6 text-[#6b7280]">
                      {section.note}
                    </p>
                  )}
                </article>
              ))}
            </div>

            <div className="rounded-[2rem] border border-[#dfe3ef] bg-white p-6 shadow-[0_18px_60px_rgba(31,41,55,0.06)] sm:p-8">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#3f51b5]">Weitere Hinweise</p>
              <div className="mt-6 divide-y divide-[#e5e7eb]">
                {infoSections.map((section) => (
                  <section key={section.title} className="py-6 first:pt-0 last:pb-0">
                    <h2 className="text-lg font-semibold text-[#111827]">{section.title}</h2>
                    <p className="mt-3 text-sm leading-7 text-[#4b5563]">{section.text}</p>
                  </section>
                ))}
              </div>
            </div>

            <div className="rounded-[2rem] bg-[#00094d] p-6 text-white shadow-[0_24px_80px_rgba(0,9,77,0.18)] sm:p-8">
              <h2 className="text-xl font-semibold tracking-[-0.02em]">Aktualitäts-Hinweis</h2>
              <p className="mt-3 text-sm leading-7 text-white/72">
                Diese Seite bildet die vorliegenden Unternehmensdaten ab. Falls sich Registerdaten, Kammerangaben, Geschäftsführung, Adresse oder Umsatzsteuer-ID ändern, muss das Impressum entsprechend aktualisiert werden.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
